import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../../../pipelines.service";
import {CurrencyPipe} from "@angular/common";

@Component({
  selector: 'pipelines-panel-loans',
  imports: [
    CurrencyPipe
  ],
  templateUrl: './pipelines-panel-loans.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-loans.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelLoansComponent implements OnInit{
  constructor(private _pipelineService: PipelinesService) {
  }
  @Input() detail:any;
  public loans:any[];
  public expanded: boolean = false;

  ngOnInit() {
    this.loans = this._pipelineService.parseField(this.detail.loans)
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }

}
